import { observable, action, runInAction, computed, toJS } from 'mobx';
import service from '@service/index';
import fetchUrl from '@service/fetchUrl';
import login_user_store from '../LoginUser/LoginUserStore';

class GlobalStore {

  @observable
  loading_count = 0;

  @action
  loading_count_add() {
    this.loading_count++;
  }

  @action
  loading_count_min() {
    if( this.loading_count > 0) {
      this.loading_count--;
    }
  }

  @computed
  get is_loading() {
    let res = this.loading_count !== 0;
    return res;
  }

  @observable
  authority_map = new Map();

  @action
  initAuthorityMap(data) {
    for(let attr in data) {
      this.authority_map.set(attr, data[attr]);
    }
    // console.log(toJS(this.authority_map))
  }
}

let global_store = new GlobalStore();

export default global_store;



// WEBPACK FOOTER //
// ./src/Store/Common/GlobalStore.js